import { EmptyState, SectionCard } from '@atlas/ui-components'
import type { FileVersion } from '@/domain/asset-detail.types'

export interface VersionHistoryPanelProps {
	versions: FileVersion[]
}

/**
 * MOCK stand-in (design §8.10): version history has no backend today — no
 * `version`/`supersedes` field exists on the real file model. Presentational + storied.
 */
export function VersionHistoryPanel({ versions }: VersionHistoryPanelProps) {
	return (
		<SectionCard title="Version history · immutable" className="space-y-3 bg-ds-surface">
			{versions.length === 0 ? (
				<EmptyState title="No prior versions." />
			) : (
				<ul className="divide-y divide-ds-border">
					{versions.map((v) => (
						<li key={v.pin} className="flex items-center justify-between py-2 text-sm">
							<span>
								<span className="mr-2 font-mono text-xs text-ds-text-muted">{v.pin}</span>
								{v.note}
							</span>
							<span className="font-mono text-xs text-ds-text-subtle">{v.date}</span>
						</li>
					))}
				</ul>
			)}
		</SectionCard>
	)
}
